<app-header (toggleEvent)="toggleNav($event)"></app-header>

<div class="container-fluid sectionContainer pt-3 pl-0 pr-0">

  <mat-sidenav-container class="example-container" [hasBackdrop]="false" autosize>
    <mat-sidenav #sidenav class="example-sidenav" mode="over" [(opened)]="sidenavToggle">
      <app-mail-box *ngIf="sidenavToggle" (closeMailEvent)="toggleNav($event)">
      </app-mail-box>
    </mat-sidenav>

    <mat-sidenav-content class="sidenav_content_flex">
      <div class="claim-letter-container container-fluid pt-5 pb-5">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center loading-spinner-container">
          <mat-spinner diameter="60" color="primary"></mat-spinner>
        </div>

        <div *ngIf="!isLoading && claimData" class="content-wrapper container">
          <div class="row mb-4">
            <div class="col-12">
              <h1 class="page-title">Claim Letter Details</h1>
              <!-- <p class="page-subtitle">View and manage documents associated with this claim.</p> -->
            </div>
          </div>

          <!-- Claim Info Card -->
          <div class="row mb-4">
            <div class="col-12">
              <mat-card class="claim-info-card">
                <mat-card-content>
                  <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <div class="info-section">
                      <span class="info-label text-uppercase">Claim ID</span>
                      <h2 class="info-value mb-0 d-flex align-items-center">
                        {{ claimData.alternateClaimId }}
                        <!-- <button mat-icon-button (click)="copyClaimId()" matTooltip="Copy Claim ID"
                          class="ms-2 copy-btn">
                          <mat-icon>content_copy</mat-icon>
                        </button> -->
                      </h2>
                    </div>
                    <div class="status-section">
                      <button mat-flat-button color="primary" class="view-claim-btn" (click)="viewClaim()"
                        matTooltip="View details of this claim">
                        View Claim
                      </button>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <!-- Documents Section -->
          <div class="row">
            <div class="col-12">
              <mat-card class="documents-card">
                <mat-card-title class="card-header-custom d-flex align-items-center">
                  <mat-icon class="me-2">description</mat-icon>
                  Associated Documents ({{ claimData.documents?.length || 0 }})
                </mat-card-title>

                <mat-card-content class="mt-3">
                  <div class="table-responsive"
                    *ngIf="claimData.documents && claimData.documents.length > 0; else noDocs">
                    <table mat-table [dataSource]="claimData.documents" class="w-100 documents-table">

                      <!-- Document Type Column -->
                      <ng-container matColumnDef="documentType">
                        <th mat-header-cell *matHeaderCellDef> Document Type </th>
                        <td mat-cell *matCellDef="let doc">
                          <span class="badge type-badge">{{ (doc.documentType?.split('_')?.join(' ') | titlecase) ||
                            'N/A' }}</span>
                        </td>
                      </ng-container>

                      <!-- Document Name Column -->
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Document Name </th>
                        <td mat-cell *matCellDef="let doc" class="fw-medium text-dark">
                          {{ doc.name || 'Unnamed Document' }}
                        </td>
                      </ng-container>



                      <!-- Actions Column -->
                      <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="text-end"> Actions </th>
                        <td mat-cell *matCellDef="let doc" class="text-end">
                          <button mat-flat-button color="primary" class="action-btn px-3" (click)="viewDocument(doc)">
                            <mat-icon class="me-1">visibility</mat-icon> View / Download
                          </button>
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="document-row"></tr>
                    </table>
                  </div>

                  <ng-template #noDocs>
                    <div class="text-center py-5 no-documents-container">
                      <mat-icon class="no-docs-icon">folder_open</mat-icon>
                      <h3>No documents found</h3>
                      <p class="text-muted">There are no documents associated with this claim yet.</p>
                    </div>
                  </ng-template>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

        </div>

        <!-- Error / Missing Token State -->
        <div *ngIf="!isLoading && (!claimData || errorMessage)"
          class="error-state-container container d-flex justify-content-center align-items-center pt-5">
          <mat-card class="error-card p-5 text-center" style="max-width: 500px; width: 100%;">
            <mat-card-content>
              <mat-icon color="warn" style="font-size: 64px; height: 64px; width: 64px; color: #dc2626;"
                class="mb-4">error_outline</mat-icon>
              <h2 class="mb-3">Unable to Load Claim Details</h2>
              <p>{{ errorMessage || 'An unexpected error occurred. Please verify your claim token.' }}</p>
              <div class="d-flex justify-content-center gap-3 mt-4">
                <button mat-flat-button color="primary" class="me-2" (click)="fetchClaimLetterData()" *ngIf="token">
                  <mat-icon class="me-1">refresh</mat-icon> Retry
                </button>
                <button mat-stroked-button color="accent" routerLink="/home">
                  Go to Home
                </button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>